import React from "react";

const AccountName = (props) => {
  const client = props.accountName
    ? props.accountName.find((client) => client.client_id === props.clientId)
    : "Not Available";

  // console.log("name------", client);
  return (
    <span className="px-3 text-lg flex flex-col ">
      {props.accountName ? client.name : ""}
    </span>
  );
};

export default AccountName;
